import { render, staticRenderFns } from "./Matches.vue?vue&type=template&id=30dd700d&"
import script from "./Matches.vue?vue&type=script&lang=js&"
export * from "./Matches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports